/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Column_TermInputs */

const en_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Term`)
};

const fr_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terme`)
};

const de_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begriff`)
};

const it_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

const ru_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок`)
};

const es_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Término`)
};

const zh_cn2_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学期`)
};

const ja_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学期`)
};

const hi_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_knp_terms_column_term = /** @type {(inputs: Knp_Terms_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo`)
};

/**
* | output |
* | --- |
* | "Term" |
*
* @param {Knp_Terms_Column_TermInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_column_term = /** @type {((inputs?: Knp_Terms_Column_TermInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Column_TermInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_column_term(inputs)
	if (locale === "de") return de_knp_terms_column_term(inputs)
	if (locale === "it") return it_knp_terms_column_term(inputs)
	if (locale === "ru") return ru_knp_terms_column_term(inputs)
	if (locale === "es") return es_knp_terms_column_term(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_column_term(inputs)
	if (locale === "ja") return ja_knp_terms_column_term(inputs)
	if (locale === "hi") return hi_knp_terms_column_term(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_column_term(inputs)
	return en_knp_terms_column_term(inputs)
});